/**
 * Mock location/spoofing data for browser fallback.
 * Used only when running outside native WebView (e.g. local dev in browser).
 */
import type { LocationData, SpoofingStatus } from '../types';

/** Default mock location: near Otemachi, Tokyo */
export const MOCK_BASE_LOCATION: LocationData = {
  lat: 35.6862,
  lng: 139.7638,
  alt: 22.7,
  accuracy: 5.0,
  timestamp: new Date().toISOString(),
};

/** Generate a randomized mock location near the base point */
export function generateMockLocation(): LocationData {
  return {
    lat: MOCK_BASE_LOCATION.lat + (Math.random() - 0.5) * 0.001,
    lng: MOCK_BASE_LOCATION.lng + (Math.random() - 0.5) * 0.001,
    alt: MOCK_BASE_LOCATION.alt,
    accuracy: 3.0 + Math.random() * 5,
    timestamp: new Date().toISOString(),
  };
}

/** Default mock spoofing status (IMU = warning, rest OK) */
export const MOCK_SPOOFING_STATUS: SpoofingStatus = {
  doppler: 'ok',
  imu: 'warning',
  signal_quality: 'ok',
  time: 'ok',
  pressure_altitude: 'ok',
  doppler_raim: 'ok',
  mock_location: 'ok',
};
